// src/pages/Enade.jsx
import React from 'react';
import { Link } from 'react-router-dom';

import './Enade.css';

const Enade = () => {
  return (
    <main className="page-enade">

      {/* Seção 1: Pioneirismo */}
      <section className="pioneering-section">
        <div className="page-content">
          <h1 className="section-title">
            A Plataforma CODI é pioneira em
            <br />Inteligência Educacional para o ENADE
          </h1>
          <p className="section-text">
            Ao combinar seus indicadores pedagógicos com algoritmos preditivos e inteligência artificial,
            a CODI é capaz de apresentar uma projeção panorâmica do quadro pedagógico da instituição de até 5 anos.
          </p>
          <Link to="/contato" className="btn btn-primary">Agende uma Demonstração</Link>
        </div>
      </section>
      {/* /Pioneirismo */}

      {/* Seção 2: Como o CODI ajuda a IES com o ENADE */}
      <section className="enade-how-section">
        <div className="page-content">
          <h3 className="section-title">
            <span>O ENADE avalia a qualidade dos cursos de graduação e impacta a reputação da sua instituição.</span> <span className="yellow">A CODI ajuda você a mapear os alunos, professores, tutores, disciplinas e conteúdos </span> que precisam de uma atenção especial.
          </h3>
        </div>
      </section>
      {/* Como o CODI ajuda a IES com o ENADE */}

      {/* Seção 3: Desafios do ENADE */}
      <section className="highlights-section">
        <div className="page-content">
          <div className="highlights-grid">

            <div className="highlight-item concluintes">
              <div className="highlight-item-container">
                <h2 className="highlight-title">Predição de <strong>Concluintes</strong></h2>
                <p className="highlight-text">Saiba com antecedência quem está prestes a se formar e precisa fazer o ENADE. Antecipe também quem poderá prestar o exame nos próximos anos.</p>
              </div>
            </div>

            <div className="highlight-item desempenho">
              <div className="highlight-item-container">
                <h2 className="highlight-title">Predição de <strong>Desempenho</strong></h2>
                <p className="highlight-text">Identifique os alunos com baixo potencial de desempenho e atue rapidamente com ações pedagógicas focadas para garantir melhores resultados no ENADE.</p>
              </div>
            </div>

            <div className="highlight-item objetos">
              <div className="highlight-item-container">
                <h2 className="highlight-title"><strong>Objetos de Conhecimento</strong></h2>
                <p className="highlight-text">Direcione estratégias de ensino mais efetivas com o mapeamento automatizado entre as <strong>disciplinas</strong> e o conteúdo do exame.</p>
              </div>
            </div>

          </div>
        </div>
      </section>
      {/* /Desafios do ENADE */}

      {/* Seção 4: Ficha Docente e CPA */}
      <section className="teacher-section">
        <div className="section-content">
          <div className="page-content">
            <div className="teacher-content">
              <h2 className="section-title">Sua CPA mais forte!</h2>
              <p className="section-text">
                Gestores acadêmicos e a CPA (Comissão Própria de Avaliação) podem contar com a CODI para relacionar indicadores em uma ficha pedagógica completa:
              </p>
              <ul className="teacher-list">
                <li>Aderência à distribuição normal de notas</li>
                <li>Facilidade e dificuldade dos alunos</li>
                <li>Aprovação e aproveitamento</li>
                <li>Assiduidade e acesso</li>
                <li>Médias por unidade, polo, curso, disciplina e turma</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
      {/* /Ficha Docente e CPA */}



      {/* Seção 3: Mapa Docente e Discente */}
      <section className="how-it-works-section">
        <div className="page-content">

          <h2 className="section-title">Acompanhamento eficiente das Atividades de Estudo</h2>
          <div className="how-it-works-container">
            <div className="how-it-works-item">
              <div className="how-it-works-item-title">Taxa de Entrega de Atividades</div>
              <div className="how-it-workds-item-content">Saiba quais turmas e disciplinas têm maior ou menor adesão de atividades.</div>
            </div>

            <div className="how-it-works-item">
              <div className="how-it-works-item-title">Mensageria Automática</div>
              <div className="how-it-workds-item-content">Dispare avisos para os alunos que não entregaram as atividades no prazo.</div>
            </div>

            <div className="how-it-works-item">
              <div className="how-it-works-item-title">Listas de contato</div>
              <div className="how-it-workds-item-content">Exporte relações de não entregas para potencializar ações de permanência.</div>
            </div>
          </div>

          <h2 className="section-title">Mapeamentos para Ações Pedagógicas</h2>
          <div className="how-it-works-container">
            <div className="how-it-works-item">
              <div className="how-it-works-item-title">Mapa Docente</div>
              <div className="how-it-workds-item-content">Tenha ferramentas para analisar a qualidade das avaliações
                de professores, tutores e disciplinas sobre seus alunos.
              </div>
            </div>

            <div className="how-it-works-item">
              <div className="how-it-works-item-title">Mapa Discente</div>
              <div className="how-it-workds-item-content">Analise o aprendizado em rankings de desempenhos pedagógicos por curso, professor, tutor e disciplina.</div>
            </div>

            <div className="how-it-works-item">
              <div className="how-it-works-item-title">Integração com o Funil</div>
              <div className="how-it-workds-item-content">Utilize as ações do Funil da Permanência para melhorar o resultado no ENADE.</div>
            </div>
          </div>

        </div>
      </section>
      {/* /Mapa Docente e Discente */}



      {/* Seção 6: Histórico Pedagógico do Aluno */}
      <section className="student-section">
        <div className="page-content">
          <h2 className="section-title">Jornada do Aluno</h2>
          <p className="section-text">
            Visualize o perfil pedagógico do aluno e seu histórico de resultados em uma tela de análise rápida,
            com acesso a notas e indicadores avançados. Combine a análise pedagógica com o perfil financeiro do aluno
            para obter uma visão completa.
          </p>
          <Link to="/financeiro" className="btn btn-secondary">Saiba Como</Link>
        </div>
      </section>
      {/* /Histórico Pedagógico do Aluno */}

    </main>
  );
};

export default Enade;
